import React, { useEffect, useState } from 'react';
import {  } from 'antd';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { constantConfig } from 'web-common';
import { queryMenuContentList } from '../../store/action';
import { NoticeItemVo } from './config/interface';


import './style/noticList.less';



const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;


// 背景图
const contactUsNoticListBgPC = require('../../assets/images/conactUs/contactUsNoticListBgPC.jpg');
const contactUsNoticListBgMOBILE = require('../../assets/images/conactUs/contactUsNoticListBgMOBILE.jpg');


/**
 * 通知公告列表
 */
const NoticeList = () => {

    const history = useHistory();

    const { isMobile } = useSelector((state: any) => state.reducer); 

    // 公告列表
    const [noticeList, setNoticeList] = useState<NoticeItemVo[]>([]);


    useEffect(() => {
		initContentList();
	}, []);


	/**
	 * 初始化公司列表
	 */
	const initContentList = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.NOTICE);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setNoticeList(arrs);
		}
	};


    /**
     * 渲染Mobile公告列表
     */
    const renderNoticeListMobile = () => {
        return (
            <div className="w h ofa pa pt30 plr16 " style={{color: '#fff', top: 36, zIndex: 2}}>
                <div className="f40">通知公告</div>
                <div className="mt20 ofa" style={{maxHeight: 480}}>
                    {
                        (noticeList || []).map((v: NoticeItemVo, vi: number) => {
                            return (
                                <div 
                                    key={vi}
                                    className="crp ptb16" 
                                    style={{borderTop: '1px solid #ddd'}}
                                    onClick={() => history.replace(`${WEBSITE_PATHS.noticeInfo}?index=${vi}`)}
                                >
                                    <div className="f18 mb8 notic-name">{v.title}</div>
                                    <div className="f14 mb8 notic-desc">{v.overview}</div>
                                    <div className="f14" style={{color: '#DDDDDD'}}>{v.publishDate}</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    };


    /**
     * 渲染PC公告列表
     */
    const renderNoticeListPC = () => {
        return (
            <div className="w h ofa pa pt30 plr75 " style={{color: '#fff', top: 56, zIndex: 2}}>
                <div className="f64">通知公告</div>
                <div className="mt50">
                    {
                        (noticeList || []).map((v: NoticeItemVo, vi: number) => {
                            const isEven = (vi + 1) % 2 === 0;
                            return (
                                <div key={vi} className="dib" style={{width: '49%', marginLeft: isEven ? "2%" : null}}>
                                    <div 
                                        className="crp flex ptb54" 
                                        style={{borderTop: '1px solid #ddd'}}
                                        onClick={() => history.replace(`${WEBSITE_PATHS.noticeInfo}?index=${vi}`)}
                                    >
                                        <div className="flex1">
                                            <div className="f24 notic-name">{v.title}</div>
                                            <div className="f14 notic-desc">{v.overview}</div>
                                        </div>
                                        <div className="w200 tr">{v.publishDate}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    };



    return (
        <div className="company-contactUs-noticList-wrapper">
            <div className="pr">
                <div className="banner ofh">
                    <img src={isMobile ? contactUsNoticListBgMOBILE : contactUsNoticListBgPC} loading="lazy" className="w" />
                </div>
                {
                    isMobile ? (renderNoticeListMobile()) : (renderNoticeListPC())
                }
            </div>
        </div>
    );
};


export { NoticeList };